import * as d3 from 'd3'
import * as dc from 'dc'

// "Operations by Currency" (Overview tab): how many RFQs came in per currency,
// NOT how much notional they carried. crossfilter's default reduce is the row
// count, so no reduceSum here.
//
// Counting instead of summing changes the story on purpose: in the June export
// five JPY tickets were 17% of the BRL-converted volume and would tower over
// the 1393 BRL operations beside them. By count JPY is 0%.
export function createCurrencyBarChart ({ el, ndx, chartGroup, width, color }) {
  const dim = ndx.dimension((d) => d.currency)
  const group = dim.group()

  const chart = new dc.BarChart(el, chartGroup)
  chart
    .width(width)
    .height(200)
    .x(d3.scaleBand().domain([]))
    .xUnits(dc.units.ordinal)
    .margins({ left: 50, right: 30, top: 25, bottom: 50 })
    .yAxisLabel('')
    .brushOn(false)
    .gap(5)
    .controlsUseVisibility(true)
    .dimension(dim)
    .elasticY(true)
    .renderHorizontalGridLines(true)
    .renderVerticalGridLines(true)
    .group(group)
    .clipPadding(40)
    .renderLabel(true)
    .label((d) => {
      const total = d3.sum(group.all(), (kv) => kv.value)
      const percent = total > 0 ? (d.data.value / total) * 100 : 0
      return `${percent.toFixed(0)}%`
    })
    .colors(color)
    .colorAccessor((d) => d.key)

  // Whole operations only. With few rows d3 can hand out fractional ticks
  // (0, 0.5, 1); formatting those as integers would print duplicate labels, so
  // the fractional ones are blanked instead.
  chart.yAxis().tickFormat((v) => (Number.isInteger(v) ? d3.format('d')(v) : '')).ticks(6)
  chart.render()
  return chart
}
